import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { icons } from './icons-provider';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { es_ES, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appInitializer } from './core/providers/app-initializer.providers';
import { provideAuthentication } from './core/providers/auth.provider';
import { provideLocalization } from '@localization';
import { LOCALIZATION_CONFIG } from './core/config/localization.config';
import {
  CONFIG_SERVICE,
  debugInterceptor,
  retryInterceptor,
  tenantInterceptor,
} from '@auth';
import { ConfigService } from './core/services/config.service';
import { provideErrorHandler } from '@errorHandler';
import { APP_ERROR_HANDLER_CONFIG } from './core/config/errors.config';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { errorInterceptor } from '../auth/interceptors/error.interceptor';
import { authHttpInterceptorFn } from '@auth0/auth0-angular';

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([
        tenantInterceptor,
        debugInterceptor,
        retryInterceptor,
        errorInterceptor,
        authHttpInterceptorFn,
      ]),
    ),
    provideRouter(routes),
    provideNzIcons(icons),
    provideNzI18n(es_ES),
    importProvidersFrom(FormsModule, NzModalModule),
    provideAnimationsAsync(),
    provideAuthentication(),
    { provide: CONFIG_SERVICE, useExisting: ConfigService },
    provideAppInitializer(() => appInitializer()),
    provideLocalization(LOCALIZATION_CONFIG),
    provideErrorHandler(APP_ERROR_HANDLER_CONFIG),
  ],
};
